module.exports = __webpack_public_path__ + "static/media/importICloud2.a1a2c1f5.png";